import { render, staticRenderFns } from "./admin-portal-permissions.vue?vue&type=template&id=46707bbb&scoped=true"
import script from "./admin-portal-permissions.vue?vue&type=script&lang=js"
export * from "./admin-portal-permissions.vue?vue&type=script&lang=js"
import style0 from "./admin-portal-permissions.vue?vue&type=style&index=0&id=46707bbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46707bbb",
  null
  
)

export default component.exports